<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
@import url("./assets/style/init.css");
@import url("//at.alicdn.com/t/font_643635_2j0zyeud869.css");
</style>
